var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "161.00 111.00 52.75 51.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f39800",
    points: "213.1 111.12 161.2 150.51 177.6 150.51 196.7 132.99 182.01 155.64 186.66 168.98 196.59 151.99 213.81 162.93 213.1 111.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneIcon);
export default __webpack_public_path__ + "static/media/paper_plane_icon.f111cc348a7801495570e28a1dbbe5fc.svg";
export { ForwardRef as ReactComponent };